import { resolveConfirmationCampaignStatsStep } from "@/services/confirmationOrder";

export function resolveOrderPageConfirmationStep(orderType) {
  return resolveConfirmationCampaignStatsStep(orderType);
}

export function shouldApplyOrderPageCampaignStatsStep() {
  return (
    window.globalConfig?.isOrderPage &&
    window.location.pathname.endsWith("/confirmation")
  );
}

export function applyOrderPageCampaignStatsStep(orderHistoryStore) {
  if (!shouldApplyOrderPageCampaignStatsStep()) {
    return;
  }

  const lastItem = orderHistoryStore.activeLastOrderHistoryItem;
  const orderType = lastItem?.order?.orderType;

  if (!lastItem?.order) {
    console.warn(
      "campaign stats — confirmation order history empty, defaulting to confirmation_initial",
    );
  }

  window.campaignStatsStep = resolveOrderPageConfirmationStep(orderType);
  document.body.dispatchEvent(new Event("runCampaignStats"));
}
